export default __webpack_public_path__ + "static/media/17407-danny.eca7eadc.pdf";